import { defineStore } from 'pinia'
import { ref } from 'vue'

// 用户信息接口
interface UserInfo {
  id: number
  nickname: string
  avatar?: string
  auths: string  // 权限字符串，以逗号分隔
  [key: string]: any
}

export const useUserStore = defineStore('user', () => {
  const token = ref<string | null>(localStorage.getItem('token'))
  const userInfo = ref<UserInfo | null>(JSON.parse(localStorage.getItem('userInfo') || 'null'))

  // 设置 token
  function setToken(newToken: string) {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }

  // 设置用户信息
  function setUserInfo(info: UserInfo) {
    userInfo.value = info
    localStorage.setItem('userInfo', JSON.stringify(info))
  }

  // 清除用户信息
  function clearUserInfo() {
    token.value = null
    userInfo.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  // 检查是否有特定权限
  function hasPermission(permission: string): boolean {
    if (!userInfo.value?.auths) return false
    // 分割权限字符串并去除每个权限的空格
    const authList = userInfo.value.auths.split(',').map(auth => auth.trim())
    return authList.includes(permission)
  }

  return {
    token,
    userInfo,
    setToken,
    setUserInfo,
    clearUserInfo,
    hasPermission
  }
})

